export const getGrpr = state => {
  return state.grpr
}

export const getLoadingParcelamento = state => {
  return state.loadingParcelamento
}
